.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(8, 12, 32, 0.72);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  z-index: 1000;
  animation: modalBackdropIn 0.2s ease-out;
}

@keyframes modalBackdropIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1001;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.modal-content {
  background: linear-gradient(135deg, #ffffff 0%, #f6f8fe 100%);
  border: 1px solid rgba(100, 108, 255, 0.15);
  pointer-events: auto;
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  width: 100%;
  will-change: transform;
}

.center-modal {
  max-width: 420px;
  border-radius: var(--border-radius-xl);
  box-shadow: 0 30px 70px -15px rgba(100, 108, 255, 0.22), 0 0 30px rgba(100, 108, 255, 0.08), 0 0 0 1px rgba(100, 108, 255, 0.12);
  margin: 20px;
  animation: modalScaleIn 0.25s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

@keyframes modalScaleIn {
  from { opacity: 0; transform: scale(0.95) translateY(10px); }
  to { opacity: 1; transform: none; }
}

[data-theme="dark"] .modal-content {
  background: linear-gradient(145deg, rgba(14, 22, 54, 0.98) 0%, rgba(7, 10, 28, 0.99) 100%);
  backdrop-filter: blur(30px);
  -webkit-backdrop-filter: blur(30px);
  border: 1px solid rgba(139, 92, 246, 0.35);
}

[data-theme="dark"] .center-modal {
  box-shadow: 0 35px 80px -10px rgba(0, 0, 0, 0.9), 0 0 45px rgba(139, 92, 246, 0.28), 0 0 0 1px rgba(139, 92, 246, 0.35);
}

.bottom-sheet {
  position: absolute;
  bottom: 0;
  max-width: 600px;
  border-radius: var(--border-radius-xl) var(--border-radius-xl) 0 0;
  box-shadow: 0 -10px 40px rgba(100, 108, 255, 0.15);
  padding-bottom: env(safe-area-inset-bottom);
  max-height: calc(100vh - env(safe-area-inset-top, 20px) - 20px);
  max-height: calc(100dvh - env(safe-area-inset-top, 20px) - 20px); /* BUG-07 fix: dvh fallback */
  touch-action: none;
}

[data-theme="dark"] .bottom-sheet {
  box-shadow: 0 -15px 45px rgba(139, 92, 246, 0.22);
}

/* Drag handle - larger touch area for swipe-to-dismiss */
.modal-drag-handle-area {
  display: flex;
  justify-content: center;
  padding: 12px 0 4px;
  cursor: grab;
  touch-action: none;
}

.modal-drag-handle {
  width: 40px;
  height: 4px;
  background: linear-gradient(90deg, var(--aurora-start, #3b82f6), var(--aurora-end, #8b5cf6));
  border-radius: 2px;
  opacity: 0.8;
  transition: all 0.2s ease;
}

.modal-drag-handle.dragging {
  width: 56px;
  opacity: 1;
  background: var(--aurora-mid, #6366f1);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid var(--surface-border);
}

.modal-title {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--text-primary);
  margin: 0;
}

.modal-close {
  background: none;
  border: none;
  font-size: 20px;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 4px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  min-width: 36px;
  min-height: 36px;
}

.modal-close:hover {
  background: var(--bg-secondary);
  color: var(--text-primary);
}

.modal-body {
  padding: 20px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

/* Mobile optimizations */
@media (max-width: 768px) {
  .center-modal {
    margin: 12px;
    max-width: calc(100vw - 24px);
    border-radius: 16px;
  }

  .bottom-sheet {
    max-width: 100%;
    border-radius: 16px 16px 0 0;
    max-height: calc(100dvh - env(safe-area-inset-top, 20px) - 20px);
  }

  .modal-header {
    padding: 12px 16px;
  }

  .modal-title {
    font-size: var(--font-size-md);
  }

  .modal-close {
    min-width: 40px;
    min-height: 40px;
    font-size: 22px;
  }

  .modal-body {
    padding: 16px;
  }

  .modal-drag-handle-area {
    padding: 10px 0 2px;
  }

  .modal-drag-handle {
    width: 36px;
    height: 4px;
  }
}

/* Apply on larger screens (disable bottom sheet behavior) */
@media (min-width: 768px) {
  .bottom-sheet {
    position: relative;
    border-radius: var(--border-radius-lg);
    bottom: auto;
    max-height: 80vh;
    touch-action: auto;
  }
  .modal-drag-handle-area {
    display: none;
  }
}

/* Small phones */
@media (max-width: 380px) {
  .center-modal {
    margin: 8px;
    max-width: calc(100vw - 16px);
    border-radius: 14px;
  }

  .modal-body {
    padding: 12px;
  }
  .modal-header {
    padding: 10px 12px;
  }
  .modal-title {
    font-size: var(--font-size-sm);
  }
}
